/**
 * Shared layout + typography for stacked bands on `/home`.
 */

/** Horizontal padding for centered home sections (match across hero, mission, carousel). */
export const HOME_SECTION_HORIZONTAL_GUTTER = { xs: 3, md: 5 };

/** Symmetric vertical padding for each band (below-hero sections; hero uses this for bottom). */
export const HOME_SECTION_BAND_PADDING_Y = { xs: 6, md: 8 };

/** Hero only: extra top padding below the fixed navbar band. */
export const HOME_SECTION_HERO_PADDING_TOP = { xs: 8, md: 8 };

/** Primary headings shared by hero title, mission statement, carousel title */
export const HOME_SECTION_HEADING_SX = {
  textAlign: "center",
  color: "#111",
  fontWeight: 600,
  fontSize: { xs: "1.875rem", sm: "2.125rem", md: "2.5rem" },
  lineHeight: 1.2,
};

/** Space beneath section headings before the next block */
export const HOME_SECTION_HEADING_BELOW_MARGIN = { mb: 3 };
